export enum OrderStatus {
	New = 'New',
	InProgress = 'InProgress',
	Sent = 'Sent',
	Canceled = 'Canceled',
}